//REDUCER
import {  START_MEDIA_DOWNLOAD, 
	UPDATE_MEDIA_DOWNLOAD, 
	STOP_MEDIA_DOWNLOAD, 
	SET_LOGIN_STATUS, 
	SET_QUEUE_STATUS, 
	RECIEVE_REVIEWS, 
	SAVING_REVIEWS, 
	SHOW_SCHEMA_ERROR, 
	SHOW_ERROR_PAGE, 
	RECIEVE_VIEWER, 
	SET_SERVER_OK, 
	SHARE_SCORE_RESULTS, 
	SET_LOCALE, 
	SET_USER_INITIALIZED, 
	SET_CATALOG_INITIALIZED, 
	SET_LESSON_INITIALIZED, 
	SET_COURSE_INITIALIZED, 
	SET_SURVEY_PAGE, 
	SET_REDIRECT_PAGE, 
	SET_LOGIN_FEEDBACK, 
	RECIEVE_LOGOUT, 
	SET_SPOTTER_CHECKBOX_STATUS, 
	SET_SPOTTER_COUNTY_STATE } from '../actions'
import { createAction, createReducer, current } from '@reduxjs/toolkit'

const initialState =
{
	fetchError: null,
	schemaError: null,
	user_initialized: false,
	lesson_initialized: null,
	catalog_initialized: false,
	course_initialized: null,
	redirect_page: null,
	login_feedback: null,
	login_is_loading: false,
	queue_is_loading: false,
	language: { locale: "en_EN",
				//locale_codes: ["auto", "en_EN", "es_ES", "fr_FR", "zh_TW", "pt_BR" ]},
				locale_codes: [/*"auto"*/, "en_EN", /*"fr_FR",*/ "es_ES"/*, "pt_BR", "ru_RU", "zh_TW" */ ]}, //Turn off till we have all the translations. 
	survey: {page: 1},
	shareScoreSuccess: null,
	savingReviewUnderway: false,
	server: getServer(),
	downloadStatus: [], //new Map(),
	spotter_is_loading: false,
	spotter_county_loading_state: 0
}

const viewer = createReducer(initialState, (builder) => {
	builder
		.addCase(createAction(RECIEVE_VIEWER), (state, action) => {
		  state.language.locale = action.json.language.locale;
	  	})
	  	.addCase(createAction(SET_LOCALE), (state, action) => {
		state.language.locale = action.locale;
		})
		.addCase(createAction(SET_CATALOG_INITIALIZED), (state, action) => {
			state.catalog_initialized = action.bool;
		})
		.addCase(createAction(SET_USER_INITIALIZED), (state, action) => {
			state.user_initialized = action.bool;
		})
		.addCase(createAction(SET_COURSE_INITIALIZED), (state, action) => {
			state.course_initialized = action.id;
		})
		.addCase(createAction(SET_LESSON_INITIALIZED), (state, action) => {
			state.lesson_initialized = action.id;
		})
		.addCase(createAction(SET_LOGIN_STATUS), (state, action) => {
			state.login_is_loading = action.isLoading;
		})
		.addCase(createAction(SET_LOGIN_FEEDBACK), (state, action) => {
			state.login_feedback = action.feedback;
		})
/*
		.addCase(createAction(START_MEDIA_DOWNLOAD), (state, action) => {
			state.downloadStatus.push({id:action.id, status: action.status, progress: action.progress, error: ""})

		})

		.addCase(createAction(STOP_MEDIA_DOWNLOAD), (state, action) => {
			const download = state.downloadStatus.find(element => element.id === action.id);
			if(download != undefined)
			{
				clearInterval(download2.timer);
			}

		})
*/
		.addCase(createAction(UPDATE_MEDIA_DOWNLOAD), (state, action) => {
			const download = state.downloadStatus.find(element => element.id === action.id);
			if(download != undefined)
			{
				download.status = action.status;
				download.progress = action.progress;
				download.error = action.error;
			}else
			{
				state.downloadStatus.push({id:action.id, status: action.status, progress: action.progress, error: ""})
			}
			
		})

		.addCase(createAction(SHOW_ERROR_PAGE), (state, action) => {
			state.fetchError = action.error;
		})
		.addCase(createAction(SHOW_SCHEMA_ERROR), (state, action) => {
			state.savingReviewUnderway = true;
		})
		.addCase(createAction(SAVING_REVIEWS), (state, action) => {
			state.savingReviewUnderway = true;
		})
		.addCase(createAction(RECIEVE_REVIEWS), (state, action) => {
			state.savingReviewUnderway = false;
		})
		.addCase(createAction(SET_SERVER_OK), (state, action) => {
			//This didn't modify the state in the last version
		})
		.addCase(createAction(SET_SURVEY_PAGE), (state, action) => {
			state.survey.page = action.page;
		})
		.addCase(createAction(SET_REDIRECT_PAGE), (state, action) => {
			state.redirect_page = action.page;
	  		state.login_feedback = null;
		})
		.addCase(createAction(SET_SPOTTER_CHECKBOX_STATUS), (state, action) => {
			state.spotter_is_loading = action.isLoading;
		})
		.addCase(createAction(SET_SPOTTER_COUNTY_STATE), (state, action) => {
			state.spotter_county_loading_state = action.state;
		})
		.addCase(createAction(SET_QUEUE_STATUS), (state, action) => {
			state.queue_is_loading = action.isLoading;	
		})
		.addCase(createAction(RECIEVE_LOGOUT), (state, action) => {
			state.login_feedback = null;
		})
		.addCase(createAction(SHARE_SCORE_RESULTS), (state, action) => {
			if(action.json.returnType === "success")
			{
				state.shareScoreSuccess = true;
			}else
			{
				state.shareScoreSuccess = false;
			}
		})
  })

export default viewer 

export const getDownloadStatus = (viewer, id) => 
{
	const download = viewer.downloadStatus.find(element => element.id === id);
	return download;
}

function getServer()
{
	let useDeved = Boolean(
		window.location.hostname === 'deved.meted.ucar.edu' ||
		window.location.hostname === 'localhost' ||
		  // [::1] is the IPv6 localhost address.
		  window.location.hostname === '[::1]' ||
		  // 127.0.0.1/8 is considered localhost for IPv4.
		  window.location.hostname.match(
			/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
		  )
	  );
	
	if (useDeved) 
	{
		return "https://deved.meted.ucar.edu/";
	}else
	{
		return "https://www.meted.ucar.edu/";
	}
	
	
}